/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_DashboardInputs */

const zh_sidebar_dashboard = /** @type {(inputs: Sidebar_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习统计`)
};

const en_sidebar_dashboard = /** @type {(inputs: Sidebar_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learning Stats`)
};

const es_sidebar_dashboard = /** @type {(inputs: Sidebar_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas`)
};

/**
* | output |
* | --- |
* | "Learning Stats" |
*
* @param {Sidebar_DashboardInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_dashboard = /** @type {((inputs?: Sidebar_DashboardInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_DashboardInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_dashboard(inputs)
	if (locale === "en") return en_sidebar_dashboard(inputs)
	return es_sidebar_dashboard(inputs)
});